import React from 'react'
import { Link } from 'react-router-dom'
import { routePaths } from '../../urls'
import { useStateValue } from '@State'
import { StatusMarker } from '../StatusMarker'

export const BrightspaceSetup = () => {
  const [state] = useStateValue()
  const { coursenum, courseToken } = state
  let setupIcon = courseToken ? 'icon_checkmark' : 'icon_notification'
  let nextLink = (
    <Link to={routePaths.brightspaceAssessments} className="btn btn-myed btn-default btn-default-myed">
      Next
    </Link>
  )
  let nextButton = courseToken ? nextLink : null
  let authLink = `/links/client_brightspace.authenticate/${coursenum}/`

  return (
    <div>
      <div className="canvas-flex-wrapper">
        <div className="canvas-form-container">
          <h2>1. Brightspace Setup</h2>
          <p>
            Use the button below to authenticate your Brightspace account.
            After successful authentication, you&apos;ll be redirected back
            here.
          </p>
          <a className="btn btn-myed btn-primary btn-primary-myed" href={authLink}>
            Authenticate
          </a>
          {nextButton}
        </div>
        <div className="canvas-statusmarker-container">
          <StatusMarker iconType={setupIcon} />
        </div>
      </div>
    </div>
  )
}

